import React from 'react';
import {
  registrationEvents,
  useRegistrationControllers,
} from '../../../../services/acceptanceRegistration';
import { Dropdown, Menu } from 'antd';
import Date from './Date';
import useDeleteRegistrationHandler from '../../../base/deleteRegistrationHandler';

const InteractiveDate = ({ record }) => {
  return (
    <Dropdown overlay={<Overlay record={record} />}>
      <Date
        date={record.recordInfo?.acceptanceDate}
        time={record.recordInfo?.acceptanceTime}
      />
    </Dropdown>
  );
};

export default InteractiveDate;

function Overlay({ record, onClick, ...props }) {
  const { notify } = useRegistrationControllers();
  const deleteRegistration = useDeleteRegistrationHandler();

  const hasResult = Boolean(record.recordInfo.acceptanceStatusAddressLifeCycle);

  const handleClick = (evt) => {
    const { key } = evt;

    if (key === 'reRegistration') {
      notify(registrationEvents.reREGISTRATION_FROM_ROOM, { room: record });
    } else if (key === 'deleteRecord') {
      deleteRegistration(record.recordInfo.intervalId);
    } else if (key === 'updateRecord') {
      notify(registrationEvents.UPDATE_REGISTRATION_FROM_ROOM, {
        room: record,
      });
    }

    onClick(evt);
  };

  return (
    <Menu {...props} onClick={handleClick}>
      <Menu.Item key="reRegistration">Перезаписать</Menu.Item>
      <Menu.Item key="deleteRecord">Удалить запись</Menu.Item>
      {!hasResult && (
        <Menu.Item key="updateRecord">Редактировать запись</Menu.Item>
      )}
    </Menu>
  );
}
